import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import { render } from "react-dom";
import { Helmet } from "react-helmet";
import Topbar from "./scenes/global/Topbar.jsx";
import SidebarZ from "./scenes/global/Sidebar.jsx";

import LandingPage from "./components/LandingPage.jsx";
//import SidebarZ from "./scenes/global/SidebarX.jsx";
import Dashboard from "./scenes/dashboard/index.jsx";
import Team from "./scenes/team/index.jsx";
import Invoices from "./scenes/invoices/index.jsx";
import Contacts from "./scenes/contacts/index.jsx";
import Bar from "./scenes/bar/index.jsx";
import Form from "./scenes/form/index.jsx";
//import SchoolAdmins from "./scenes/form/SchoolAdmins.jsx";
import SchoolAdmins from "./scenes/school_admins/index.jsx";

import SchoolTMTHeadMaster from "./scenes/school_top_mg_teachers/index.jsx";
import SchoolTMTAcademicMaster from "./scenes/school_top_mg_teachers/index2.jsx";
import SchoolTMTClassTeachers from "./scenes/school_top_mg_teachers/index3.jsx";

import Organization from "./scenes/organization/index.jsx";

//OrganizationAddSchool

//import Organization from "./scenes/organization/index.jsx";


import ParentExamsResults from './scenes/form/ParentExamsResults.jsx'

import DistrictAdmins from "./scenes/schools_owners/index.jsx";

import SchoolOwners from "./scenes/schools_owners/index.jsx";

import SchoolStudents from "./scenes/school_students/index.jsx";
import SchoolClass from "./scenes/form/SchoolClass.jsx";

import SchoolSubClass from "./scenes/form/SchoolSubClass.jsx";

//SchoolAdmins
import TestForm from "./scenes/form/TestForm.jsx";
import CMMForm from "./scenes/form/CMMForm.jsx";

import School from "./scenes/school/index.jsx";
//import PatientRegistrationForm from "./scenes/form/PatientRegistrationForm.jsx"; teamOnWebsite

import PRFHooks from "./scenes/form/PRFHooks.jsx";
import ProjectCategoryContainer from "./scenes/form/ProjectCategoryContainer.jsx";
import FormProjects from "./scenes/form/FormProjects.jsx";
import FormNewWebTeam from "./scenes/form/FormNewWebTeam.jsx";
///    FormCompanyContainer
import FormCompanyContainer from "./scenes/form/FormCompanyContainer.jsx";

import FormUsersCont from "./scenes/form/FormUsersCont.jsx";
//import RFHFormSubmit from "./scenes/form/RFHFormSubmit.jsx";

//import PRFDetails from "./scenes/form/PRFDetails.jsx";

import Line from "./scenes/line/index.jsx";
import Pie from "./scenes/pie/index.jsx";
import FAQ from "./scenes/faq/index.jsx";
import Geography from "./scenes/geography/index.jsx";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar.jsx";
import LoginEXT from "./scenes/form/Login.jsx";
import StudentStream from "./scenes/form/StudentStream.jsx";
import SchoolExams from "./scenes/form/SchoolExams.jsx";

//
import ExamSubjects from "./scenes/exam_subjects/index.jsx";

import StudentExamScore from "./scenes/form/StudentExamScore.jsx";

import Announcements from "./scenes/form/Announcements.jsx";

import SchoolTeachers from "./scenes/school_teachers/index.jsx";

import TransferStudents from "./scenes/form/TransferStudents.jsx";

import SubClassExamsResults from "./scenes/form/SubClassExamsResults.jsx";

import SubClassExamReportsTopLevel from "./scenes/form/SubClassExamReportsTopLevel.jsx";

import ParentUsernameAndPasswords from "./scenes/form/ParentUsernameAndPasswords.jsx";

//AnnouncementsLists
import ListOfAnnouncements from "./scenes/form/ListOfAnnouncements.jsx"
//DistrictExamsData
import ListOfParentAnnouncements from "./scenes/form/ListOfParentAnnouncements.jsx"
//
import DistrictExamsData from "./scenes/form/DistrictExamsData.jsx";

import ExamReportsForParentsAfterLogin from "./scenes/form/ExamReportsForParentsAfterLogin";
//import ParentExamsResults from "./scenes/form/ParentExamsResults.jsx";
//import Contact from "./pages/Contact";   path('systemUsers', index),
//import NoPage from "./pages/NoPage";
import { useSearchParams } from 'react-router-dom'; 

import Home from './pages/home/index';
import HomeTwo from './pages/home-2';
import HomeThree from './pages/home-3';
import About from './pages/about';
import Course from './pages/course';
import CourseList from './pages/course/course-list';
import CourseDetails from './pages/course/course-details';
import CourseSidebar from './pages/course/course-sidebar';
import Instructor from './pages/instructor';
import InstructorDetails from './pages/instructor/instructor-details';
import Event from './pages/event';
import EventSidebar from './pages/event/event-sidebar';
import EventDetails from './pages/event/event-details';
import Blog from './pages/blog';
import BlogDetails from './pages/blog/blog-details';
import Login from './pages/authentication/login';
import Signup from './pages/authentication/signup';
import Contact from './pages/contact';
//import Error from '../pages/404';
import LoadTop from './components/ScrollTop/LoadTop'


function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  const [showContainer, setShowContainer]=useState(false);

  const [showParentReport, setShowParentReport]=useState(false);
  
  const [schools, setSchools]=useState([])

  const [organizationId, setOrganizationId]=useState(0)
  const [organizationName, setOrganizationName]=useState('')
  //const [searchParams, setSearchParams]=useSearchParams();
  //const stestr = searchParams.get('ste');

  const [loggedInUserId, setLoggedInUserId]=useState('');
  const [loggedInUserName, setLoggedInUserName]=useState('');
  const [loggedInUserCategory, setLoggedInUserCategory]=useState('');
  const [userRolesList, setUserRolesList]=useState([]);
  const [loginCategory, setLoginCategory]=useState('');
  const [loginDetailsForm, setLoginDetailsForm]=useState({});
  const [schoolDetails, setSchoolDetails]=useState({})
  const [schoolName, setSchoolName]=useState('')
  const [schoolId, setSchoolId]=useState('')
  
  const [studentsGlobal, setStudentsGlobal]=useState([]);
  
  const [mobileNo, setMobileNo]=useState('');
  const handleLogout=(data)=>{
    setShowContainer(data)
  }
 
  const handleLogin=(data, usersId, userName, loginCategoryName, rolesList, loginDetailsForm, schoolDetails, loginDetails)=>{
    setShowContainer(data)
    setLoggedInUserId(loginDetails['usersId'])
    setLoggedInUserName(loginDetails['fullName'])
    console.log("ABFG name=" + userName)
    setLoggedInUserCategory(loginDetails['loginCategory'])

    setSchools(loginDetails['schools'])
    setOrganizationId(loginDetails['organizationId'])
   // alert(loginDetails['mobileNo'])
    //alert(loginDetails['test'])
    //alert(loginDetails['schools'])
    //alert("loginDetails['students']=" + loginDetails['students'])
    //alert("mobileNo=" + loginDetails['mobileNo'])

    setStudentsGlobal(loginDetails['students'])
    setMobileNo(loginDetails['mobileNo'])

    console.log("ABFG loginCategoryName=" + loginDetails['loginCategory'])
    
    console.log("WED =" + loginDetails['fullName'])
    
    //usersId, fullName, loginCategoryName
    setUserRolesList(rolesList)
    setLoginCategory(loginDetails['loginCategory']) ///
    setLoginDetailsForm(loginDetailsForm)
    setSchoolName(schoolDetails['schoolName'])
    setSchoolId(schoolDetails['schoolId'])
    console.log("WED 11 =" + schoolDetails['schoolId'])
    
    //alert(loginDetails['loginCategory']);
    //alert("345");

    if(loginDetails['loginCategory']==="Parent"){
      //alert("poi");
      //loggedInUserName
      setLoggedInUserName("Parent of student " + loginDetails['fullName'])
    }

 }


return (
  <BrowserRouter>
    
    {
       showContainer? (<></>):(
        <>
        {/***
        <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
       </Helmet>
      <LandingPage sendDataToParent={handleLogin} />***/}
      <Home sendDataToParent={handleLogin} />
      </>
       )
      }
      
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
        
        { showContainer?
        (
          <SidebarZ isSidebar={isSidebar} 
          loginCategory={loginCategory}
          userId={loggedInUserId} 
          userName={loggedInUserName}
          />
        ):('')
       }
          <main className="content">
          { showContainer?
        (

          <>
            <Topbar setIsSidebar={setIsSidebar} 
            loginCategory={loginCategory}
            userId={loggedInUserId} 
            userName={loggedInUserName}
            schoolName={schoolName}
            schoolId={schoolId}
            sendDataToParent={handleLogout}
            />
    
        <Routes>
          <Route path="/" element={<Dashboard />} />
          
          <Route path="/schoolAdmins" element={<SchoolAdmins />} /> 

          <Route path="/SchoolTMTHeadMaster" element={<SchoolTMTHeadMaster schoolIdGlobal={schoolId} />} /> 

          <Route path="/SchoolTMTAcademicMaster" element={<SchoolTMTAcademicMaster schoolIdGlobal={schoolId} />} /> 

          <Route path="/SchoolTMTClassTeachers" element={<SchoolTMTClassTeachers schoolIdGlobal={schoolId} />} /> 
           
          <Route path="/SchoolOwners" element={<SchoolOwners />} /> 

          {/**<Route path="/districtAdmins" element={<DistrictAdmins />} /> */}

          <Route path="/schoolTeachers" 
          element={<SchoolTeachers schoolIdGlobal={schoolId} />} /> 
          

          <Route path="/LandingPage" 
          element={<LandingPage />} /> 
          
        
         <Route path="/ListOfAnnouncements" 
          element={<ListOfAnnouncements 
          loginCategory={loginCategory} 
          schoolIdGlobal={schoolId}
          usersId={loggedInUserId}
          
          />} /> 

         
         <Route path="/ListOfParentAnnouncements" 
          element={<ListOfParentAnnouncements 
          
          studentsGl={studentsGlobal}
          mobileNo={mobileNo}
          />} /> 


          <Route path="/ExamReportsForParentsAfterLogin" 
          element={<ExamReportsForParentsAfterLogin schoolIdGlobal={schoolId} studentsGl={studentsGlobal} />} /> 
         
          <Route path="/SchoolStudents" 
          element={<SchoolStudents schoolIdGlobal={schoolId} schoolName={schoolName} userName={loggedInUserName} />} 
          />
         
          <Route path="/SchoolClass" 
          element={<SchoolClass schoolIdGlobal={schoolId} />} 
          />


          <Route path="/SchoolSubClass" 
          element={<SchoolSubClass schoolIdGlobal={schoolId} />} />
          <Route path="/StudentStream" element={<StudentStream />} />
          
          <Route path="/TransferStudents" 
          element={<TransferStudents schoolIdGlobal={schoolId} />} />
          
      

          <Route path="/ParentExamsResults" 
          element={<ParentExamsResults schoolIdGlobal={schoolId} />} />
          
          <Route path="/ParentUsernameAndPasswords" 
          element={<ParentUsernameAndPasswords schoolIdGlobal={schoolId} />} />
          

          <Route path="/SubClassExamsResults" 
          element={<SubClassExamsResults schoolIdGlobal={schoolId} />} />
          
          <Route path="/SubClassExamReportsTopLevel" 
          element={<SubClassExamReportsTopLevel schoolsEXT={schools} />} />
          

          <Route path="/DistrictExamsData" 
          element={<DistrictExamsData schoolIdGlobal={schoolId} organizationIdEXT={organizationId} />} />
          

          <Route path="/ParentReports" 
          element={<ParentExamsResults schoolIdGlobal={schoolId} />} />

          
          
          <Route path="/SchoolExams" 
          element={<SchoolExams schoolIdGlobal={schoolId} />} />

          <Route path="/ExamSubjects" 
          element={<ExamSubjects schoolIdGlobal={schoolId} usersId={loggedInUserId}   />} 
          />

          <Route path="/StudentExamScore" 
          element={<StudentExamScore schoolIdGlobal={schoolId} usersId={loggedInUserId} />} 
          />

          <Route path="/organization" element={<Organization />} />

          <Route path="/school" element={<School />} />
          <Route path="/team" element={<Team />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/contacts" element={<Contacts />} />

          {/***/}
          <Route path="/patientRegistration" element={<PRFHooks />} /> 
          {/***/}
          <Route path="/patientRegistrationRecords" element={<Contacts />} /> 
          {/**/}
           <Route path="/primaryProjectCategoryList" element={<ProjectCategoryContainer />} /> 
           {/* **/}
           <Route path="/primaryProjects" element={<FormProjects />} />
           <Route path="/teamOnWebsite" element={<FormNewWebTeam />} />
           <Route path="/systemUsers" element={<FormUsersCont />} />
           <Route path="/company" element={<FormCompanyContainer />} />
          {/** <Route path="/patientRegistration" element={<Antd />} /> FormUsersCont **/}
          {/** <Route path="/patientRegistration" element={<Antd />} /> **/}
          <Route path="/primaryProjectCategoryListT" element={<CMMForm />} /> 
          
          <Route path="/testform" element={<TestForm />} />
          
          <Route path="/Announcements" element={<Announcements usersId={loggedInUserId} />} />

          
          
          
          <Route path="/invoices" element={<Invoices />} />
         
          <Route path="/form" element={<Form />} />
           
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/bar" element={<Bar />} />
          <Route path="/pie" element={<Pie />} />
          <Route path="/line" element={<Line />} />
          <Route path="/geography" element={<Geography />} />


                    <Route path="/" exact element={<Home />} />
                    <Route path="/home-2" element={<HomeTwo />} />
                    <Route path="/home-3" element={<HomeThree />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/course" exact element={<Course />} />
                    <Route path="/course-list" exact element={<CourseList />} />
                    <Route path="/course/:id" element={<CourseDetails />} />
                    <Route path="/course-sidebar" element={<CourseSidebar />} />
                    <Route path="/event" exact element={<Event />} />
                    <Route path="/event/:id" element={<EventDetails />} />
                    <Route path="/event-sidebar" element={<EventSidebar />} />
                    <Route path="/blog" exact element={<Blog />} />
                    <Route path="/blog/:id" element={<BlogDetails />} />
                    <Route path="/instructor" exact element={<Instructor />} />
                    <Route path="/instructor/:id" exact element={<InstructorDetails />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/contact" element={<Contact />} />
                    
          </Routes>
      
      </>


      )
      :(
        <>
       
      
   
      </>
     )
     }


    
      </main>
         
         </div>
         </ThemeProvider>
         </ColorModeContext.Provider>
       
  </BrowserRouter>
  );
}

//const appDiv=document.getElementById("app");old
//render(<App />, appDiv)old
export default App;